import * as styles from '@core/components/ImageViewer/ImageViewer.css';
import { Icon, StatusCircleErrorX, IconSize } from '@soteria/design-system-ve';

export interface ImageErrorProps {
  imageUrl: string;
}

/**
 * Error state component
 */
export function ImageError({ imageUrl }: ImageErrorProps) {
  return (
    <div className={styles.errorContainer}>
      <div className={styles.errorIcon}>
        <Icon icon={StatusCircleErrorX} iconSize={IconSize.Large} />
      </div>
      <p className={styles.errorText}>Unable to display image preview. Ensure URL is valid.</p>
      <p className={styles.errorSubtext}>CORS restrictions may prevent preview.</p>
      <p className={styles.errorUrl}>{imageUrl}</p>
    </div>
  );
}
